<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Categories">
      <button class="btn btn-primary" @click="newCategory">
        Add Category
      </button>
    </PageHeader>

    <Modal :open.sync="showCategoryForm" :title="mode.title">
      <div class="p-6">
        <form @submit.prevent="mode.function" class="space-y-4">
          <fieldset>
            <label for="name" class="form-label">Name</label>
            <input id="name" type="text" class="form-input" v-model="form.name">
          </fieldset>
          <div class="flex items-center justify-between">
            <button class="btn btn-primary" v-submitting="submitting">
              {{ mode.action }}
            </button>
            <!-- <button class="text-red-500" v-if="mode.title === 'Edit Category'" @click="removeCategory()" v-submitting="submitting">
              Remove
            </button> -->
          </div>
        </form>
      </div>
    </Modal>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="categories.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            This account doesn't have any categories.
          </p> 
          <button class="btn btn-secondary" @click="newCategory">
            Add Category
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table 
            :items="categories.data" 
            :keys="[
              { name: 'Name', slug: 'name', class: 'font-bold' }
            ]">
            <template #actions="{ item }">
              <button class="btn btn-sm btn-secondary" @click="editCategory(item)">
                Edit
              </button>
            </template>
          </data-table>
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="categories.meta.total" :per-page="categories.meta.per_page" :current-page="categories.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CategoryList',

  metaInfo: {
    title: 'Categories'
  },

  created () {
    this.getCategories()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      submitting: false,
      showCategoryForm: false,
      mode: {
        title: 'Add Category',
        function: this.createCategory,
        action: 'Add Category'
      },
      form: {
        name: ''
      },
      categories: []
    }
  },

  methods: {
    newCategory () {
      this.mode = {
        title: 'Add Category',
        function: this.createCategory,
        action: 'Add Category'
      }
      this.form = {
        name: ''
      }
      this.showCategoryForm = true
    },

    editCategory (category) {
      this.mode = {
        title: 'Edit Category',
        function: this.updateCategory,
        action: 'Save Changes'
      }
      this.form = JSON.parse(JSON.stringify(category))
      this.showCategoryForm = true
    },

    async getCategories () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/categories`)
        this.categories = data.categories
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },

    async createCategory () {
      try {
        this.submitting = true
        await this.$api.post(`account/${this.$route.params.account}/categories`, this.form)
        this.showCategoryForm = false
        this.form = {
          name: ''
        }
        this.getCategories()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    },

    async updateCategory () {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/categories/${this.form.id}`, this.form)
        this.showCategoryForm = false
        this.form = {
          name: ''
        }
        this.getCategories()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    },

    // async removeCategory (category) {
    //   if (window.confirm('Are you sure you want to remove this category from your account?')) {
    //     try {
    //       this.submitting = true
    //       await this.$api.delete(`account/${this.$route.params.account}/categories/${this.form.id}`)
    //       this.getCategories()
    //     } catch (error) {
    //       console.error(error)
    //     } finally {
    //       this.submitting = false
    //     }
    //   }
    // }
  }
}
</script>